import React from 'react';
import { TextField, Box, Typography, Button } from '@mui/material';

const NewAppFormFields = ({ form, handleChange, showFileInput = true, width = '50%' }) => {
  return (
    <>
      <Typography variant="h4" fontWeight={700} color="black" mt={4}>
        New App Info
      </Typography>
      <Typography variant="h6" color="rgb(158, 151, 151)" mt={2}>
        Fill in your app details to upload it to the App Zoo.
      </Typography>
      <Box
        sx={{
          width: width,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          padding: 2,
          mt: 1,
        }}
      >
        <TextField
          required
          label="App Name"
          name="name"
          value={form.name || ''}
          onChange={handleChange}
          fullWidth
          autoComplete="off"
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        />
        <TextField
          label="Description"
          name="description"
          value={form.description || ''}
          onChange={handleChange}
          fullWidth
          multiline
          minRows={2}
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        />
        <TextField
          required
          label="GitHub http(s) URL"
          name="github_url"
          value={form.github_url || ''}
          onChange={handleChange}
          fullWidth
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        />
        <TextField
          required
          label="PAT Token"
          name="pat_token"
          value={form.pat_token || ''}
          onChange={handleChange}
          fullWidth
          multiline
          minRows={3}
          placeholder="Paste your GitHub Personal Access Token here"
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        />
        {showFileInput && (
          <Button
            variant="outlined"
            component="label"
            sx={{ borderRadius: '12px', mt: 2 }}
          >
            Upload Preview Image
            <input
              type="file"
              name="preview_image"
              accept="image/*"
              hidden
              onChange={handleChange}
            />
          </Button>
        )}
      </Box>
    </>
  );
};

export default NewAppFormFields;
